"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MapSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15,4.14021928 L15,13.1096118 C15,13.5684794 14.6877026,13.9684625 14.2425356,14.0797543 L10.5,15.0153882 L6.5,14.015 L3.24261439,14.8296274 C2.70683036,14.9636196 2.16386942,14.637903 2.02987719,14.102119 C2.01003401,14.0227736 2,13.9412936 2,13.8595046 L2,4.8903882 C2,4.43152056 2.31229737,4.03153745 2.75746437,3.9202457 L6.5,2.9846118 L10.5,3.984 L13.7575885,3.17004576 C14.2934006,3.03616559 14.8362934,3.36199576 14.9701735,3.8978078 C14.9899831,3.9770894 15,4.05850029 15,4.14021928 Z M6.5,4.015 L3,4.89 L3,13.859 L5.99695381,13.1102945 L6,11 L7,11 L7.00240816,13.1101451 L10.5,13.984 L14,13.109 L14,4.14 L11.0008624,4.88944594 L11,7 L10,7 L10.0012841,4.88997605 L6.5,4.015 Z M11,11 L11,13 L10,13 L10,11 L11,11 Z M7,8 L7,10 L6,10 L6,8 L7,8 Z M11,8 L11,10 L10,10 L10,8 L11,8 Z M7,5 L7,7 L6,7 L6,5 L7,5 Z" })));
};
MapSmall.displayName = 'MapSmall';
exports.default = MapSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MapSmall.js.map